import React from "react";

import { Root } from "./styles";

interface HeaderRootProps {
  children: React.ReactNode;
}

export const HeaderRoot = ({ children }: HeaderRootProps) => {
  return <Root>{children}</Root>;
};
